import { render, staticRenderFns } from "./remessa_tse.vue?vue&type=template&id=504a343f&"
import script from "./remessa_tse.vue?vue&type=script&lang=js&"
export * from "./remessa_tse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports